import clsx from 'clsx';

const Price = ({
  amount,
  className,
  currencyCode = 'XOF',
  currencyCodeClassName
}: {
  amount: string;
  className?: string;
  currencyCode: string;
  currencyCodeClassName?: string;
} & React.ComponentProps<'p'>) => {
  // Format XOF (Franc CFA) manually since Intl.NumberFormat doesn't handle it well
  if (currencyCode === 'XOF') {
    const formattedAmount = new Intl.NumberFormat('fr-FR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(parseFloat(amount));
    
    return (
      <p suppressHydrationWarning={true} className={className}>
        {`${formattedAmount} F CFA`}
      </p>
    );
  }

  // For other currencies, use standard formatting
  return (
    <p suppressHydrationWarning={true} className={className}>
      {`${new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyCode,
        currencyDisplay: 'narrowSymbol'
      }).format(parseFloat(amount))}`}
      <span className={clsx('ml-1 inline', currencyCodeClassName)}>{`${currencyCode}`}</span>
    </p>
  );
};

export default Price;



